module.exports = __webpack_public_path__ + "static/img/zong.0528f9e4.png";